import { createSelector } from 'reselect'

const playground_nearpod_picker_section_selector = createSelector(
	[ state => state.playground.nearpod_picker ],
	nearpod_picker => ({
		audio: nearpod_picker.audio,
		audio_recorder: nearpod_picker.audio_recorder,
		gif: nearpod_picker.gif,
		image: nearpod_picker.image,
		pdf: nearpod_picker.pdf,
		video: nearpod_picker.video,
		web: nearpod_picker.web,
	})
)

export default playground_nearpod_picker_section_selector
